<template>
  <div id="contactUs" class="">
    <title-w-star title="Contact Us" titleColor="#603813" :starIconObj="{ componentName: 'shared', imgName: 'starIconBlue', imgFormat: 'svg' }" />

    <div id="contactUsFormFrame" class="font-jost bg-grey-background m-14 p-20 rounded-3xl">
      <Form ref="form" id="contactUsForm" @submit="sendMsg" :validation-schema="schema">
        <div class="flex space-x-14 text-lg">
          <span class="w-1/2 flex items-center">
            <span>{{ t("contactUs.name") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="nameError">{{ nameError }}</span>
          </span>
          <span class="w-1/2 flex items-center">
            <span>{{ t("contactUs.companyName") }}</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="companyNameError">{{ companyNameError }}</span>
          </span>
        </div>
        <div class="flex space-x-14">
          <input v-model="name" type="text" name="name" class="border border-input-border rounded px-3 h-12 w-1/2" />
          <input v-model="companyName" type="text" name="companyName" class="border border-input-border rounded px-3 h-12 w-1/2" />
        </div>
        <div class="flex space-x-14 text-lg pt-10">
          <span class="w-1/2 flex items-center"
            ><span>{{ t("contactUs.contactNumber") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="contactNumberError">{{ contactNumberError }}</span>
          </span>
          <span class="w-1/2 flex items-center"
            ><span>{{ t("contactUs.emailAddress") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="emailAddressError">{{ emailAddressError }}</span>
          </span>
        </div>
        <div class="flex space-x-14">
          <input v-model="contactNumber" type="text" name="contactNumber" class="border border-input-border rounded px-3 h-12 w-1/2" />
          <input v-model="emailAddress" type="text" name="emailAddress" class="border border-input-border rounded px-3 h-12 w-1/2" />
        </div>
        <div class="flex space-x-14 text-lg pt-10">
          <span class="w-1/2 flex items-center"
            ><span>{{ t("contactUs.message") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="messageError">{{ messageError }}</span></span
          >
        </div>
        <div>
          <textarea id="message" v-model="message" name="message" rows="6" class="resize-none border border-input-border rounded px-3 w-full" />
        </div>
        <button-util buttonType="submit" bgColor="#603813" label="contactUs.sendMessage" @click="sendMsg" class="mt-10" />
      </Form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHeaderStore } from "@/stores/header";
import { useFooterStore } from "@/stores/footer";
import { computed, onMounted, onUnmounted, ref, toRefs } from "vue";
import { useForm, useField } from "vee-validate";
import { object, string } from "yup";
import { useRouter } from "vue-router";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const headerStore = useHeaderStore();
const footerStore = useFooterStore();
const router = useRouter();
const commonStore = useCommonStore();

onMounted(async () => {});

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
// Define a validation schema
const schema = computed(() => {
  return object({
    name: string().required(t("contactUs.nameRequired")),
    companyName: string(),
    contactNumber: string().required(t("contactUs.contactNumberRequired")).matches(phoneRegExp, t("contactUs.contactNumberInvalid")),
    emailAddress: string().required(t("contactUs.emailRequired")).email(),
    message: string().required(t("contactUs.msgRequired")),
  });
});
// Create a form context with validation schema
const { handleSubmit, isSubmitting, meta } = useForm({
  validationSchema: schema,
  initialValues: {
    name: "",
    companyName: "",
    contactNumber: "",
    emailAddress: "",
    message: "",
  },
});

const { value: name, errorMessage: nameError } = useField<string>("name");
const { value: companyName, errorMessage: companyNameError } = useField<string>("companyName");
const { value: contactNumber, errorMessage: contactNumberError } = useField<string>("contactNumber");
const { value: emailAddress, errorMessage: emailAddressError } = useField<string>("emailAddress");
const { value: message, errorMessage: messageError } = useField<string>("message");

const sendMsg = handleSubmit(async (values, actions) => {
  //debugger;

  console.log("sendMsg");
  let detail = {
    contactEntryPoint: headerStore.routerName,
    name: name.value,
    companyName: companyName.value,
    contactNumber: contactNumber.value,
    emailAddress: emailAddress.value,
    text: message.value,
    message: "Name: " + name.value + "<br />" + "Company Name: " + companyName.value + "<br />" + "Contact Number: " + contactNumber.value + "<br />" + "Email Address: " + emailAddress.value + "<br />" + "Message: <br />" + message.value.replace(/\n/g, "<br />"),
  };
  //replace \n to <br> for new line
  var isSuccess = await footerStore.contactUs(detail);
  console.log("isSuccess?" + isSuccess);
  if (isSuccess) actions.resetForm();
});

/*
router.beforeEach(async (to, from) => {
  debugger;
  //clear input
  name.value = "";
  companyName.value = "";
  contactNumber.value = "";
  emailAddress.value = "";
  message.value = "";
  document.getElementById("nameError").innerHTML = "";
  document.getElementById("companyNameError").innerHTML = "";
  document.getElementById("contactNumberError").innerHTML = "";
  document.getElementById("emailAddressError").innerHTML = "";
  document.getElementById("messageError").innerHTML = "";
});
*/
</script>